import { cva } from "class-variance-authority";

export const metricCardVariants = cva("", {
  variants: {
    variant: {
      default: "border-none dark:shadow-sm lg:border lg:shadow-md",
      gradient:
        "dark:shadow-sm dark:lg:shadow-md bg-gradient-to-br from-background-alt via-[var(--metric-card-gradient-via)] to-[var(--metric-card-gradient-to)]",
      foreground: "border-none shadow-sm lg:shadow-md bg-foreground/5 backdrop-blur-md",
      primary: "border-none shadow-sm lg:border lg:shadow-md bg-primary/5 backdrop-blur-md",
      background: "border-none shadow-sm lg:border lg:shadow-md bg-background/5 backdrop-blur-md",
    },
  },
  defaultVariants: { variant: "default" },
});

export const metricCardIconClassName = "rounded-lg lg:rounded-full p-2 bg-primary/10";
